export enum RoundTypesEnum {
  Sport = 'SPORT',
  Other = 'OTHER',
  Text_streak = 'TEXT_STREAK',
  Video_streak = 'VIDEO_STREAK'
}
